import Header from "../../components/AppHeader";
import CartItem from "../../components/CartItem";
import CustomIcon from "../../components/CustomIcon";
import Dot from "../../components/Dot";
import Indicator from "../../components/Indicator";
import ModalScheduleLogistic from "../../components/ModalScheduleLogistic";
import PageContainer from "../../components/PageContainer";
import Modal from "../../components/ReactNativeModal";
import theme from "../../configs/theme-config";
import { CreditContext } from "../../contexts/credit";
import useProfile from "../../ducks/user/hooks/useProfile";
import {
  EVENT_TYPES,
  logEvent,
  logMetrixEvent,
  METRIX_EVENT_TYPES,
} from "../../helpers/analytics-helper";
import { iosSafeArePadding } from "../../helpers/general";
import { formatError } from "../../helpers/general";
import { scheduledDateTitle } from "../../helpers/logistics-helper";
import { formatOrderItem } from "../../helpers/normalizer";
import { useCancelOrder } from "../../hooks/useCancelOrder";
import useFocusEffect from "../../hooks/useFocusEffect";
import useNavigation from "../../hooks/useNavigation";
import useOrder from "../../hooks/useOrder";
import { useRescheduleOrder } from "../../hooks/useRescheduleOrder";
import useRoute from "../../hooks/useRoute";
import useSaveBasket from "../../hooks/useSaveBasket";
import ModalAddCredit from "../../components/ModalAddCredit";
import {
  LegacyHistoryLogisticsType,
  LegacyInvoiceType,
  Order,
} from "../../types/server";
import Section from "../Section";
import {
  Box,
  Typography,
  Divider,
  Stack,
  Spacer,
  Button,
  ModalContent,
  LogisticsHistory,
  useToast,
} from "digiwash-components";
import { formatNumber } from "digiwash-core";
import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  ActivityIndicator,
  Linking,
  Platform,
  SafeAreaView,
  BackHandler,
} from "react-native";
import BasketInvoiceNew from "../BasketInvoiceNew";
import { services_to_ga_purchase } from "../../helpers/ga-helper";
import HeaderContainer from "../HeaderContainer";
import { Route } from "../../types/general";
import { useListenToDeepLinks } from "../../hooks/useListenToDeepLinks";
import useSyncFilterWithParam from "../../hooks/useSyncFilterWithParam";
import useOrdersNeedsActionList from "../../ducks/user/hooks/useOrdersNeedsActionList";
import { useFreeLogistic } from "../../hooks/useFreeLogistic";
import { useLogisticPrice } from "../../hooks/useLogisticPrice";

let nativeStyles = {
  container: {
    width: "100%",
    backgroundColor: "white",
    position: "absolute",
    bottom: 0,
    left: 0,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    padding: 24,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
    elevation: 9,
  },
  bar: {},
};

let webStyles = {
  container: {
    position: "fixed",
    padding: 24,
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    boxShadow: "0px 0px 4px rgba(33, 33, 33, 0.16)",
    maxWidth: 768,
    zIndex: 1,
    alignItems: "center",
  },
  bar: {
    backgroundColor: "#fff",
    maxWidth: 768,
    margin: "auto",
    width: "100%",
    border: "1px solid #ccc",
    borderBottom: "",
    borderTopRightRadius: "16px",
    borderTopLeftRadius: "16px",
  },
};
let overrideStyles = Platform.OS === "web" ? webStyles : nativeStyles;
let styles = {
  ...overrideStyles,
};

let Container = Platform.OS === "web" ? Box : SafeAreaView;

let logisticPrivileges = [
  "اولویت در زمان جمع آوری و تحویل",
  "بسته بندی ویژه و محافظت شده(کاور)",
];

function totalActiveOrdersPrice(activeOrders: Order[]): number {
  let output = activeOrders.reduce(
    (a, b) => a + b.price_descriptor.total_price,
    0
  );

  return output;
}

interface RouteParams {
  order_id: number;
  payment_status: string;
}

function OrderDetails() {
  let inPersonAddresses = [23001, 23002, 23003];
  let { params, reset } = useSyncFilterWithParam();
  let added_address = params?.added_address;
  let nav = useNavigation();
  let route = useRoute<Route<RouteParams>>();
  let toast = useToast();
  useListenToDeepLinks();
  let { data: profileData, revalidate: revalidateProfileData } = useProfile();
  let { rescheduleOrder } = useRescheduleOrder();
  let order_id = Number(route.params.order_id);
  let { cancelOrder } = useCancelOrder();
  let [logisticSelectedTask, setLogisticSelectedTask] =
    useState<LegacyHistoryLogisticsType>(undefined);
  let { retrieve: logisticRetrieve, data: logisticPrice } = useLogisticPrice();
  let {
    data,
    revalidating: loading,
    revalidate,
    error,
  } = useOrder({ order_id });
  let { freeLogisticPrice } = useFreeLogistic();
  let step = null;
  let callout = "";
  let calloutColor = "";
  let invoice: LegacyInvoiceType = undefined;
  if (!loading && data) {
    invoice = data.legacyInvoice;
  }
  let { data: activeOrders } = useOrdersNeedsActionList();
  let [isCancelOrderModalOpen, setIsCancelOrderModalOpen] = useState(false);
  let [visibleSelectModeModal, setVisibleSelectModeModal] = useState(false);
  let [showGateways, setShowGateways] = useState(false);


  const hasShopService = () => {
    return data?.services?.some((service) =>
      service.pricing?.some((price) => price.variation?.id === "srvv_6"),
    );
  };

  if (
    data?.metadata?.legacy_latest_status === "ready_to_collect" ||
    data?.metadata?.legacy_latest_status === "collected"
  ) {
    step = 0;
    if (data?.metadata?.legacy_latest_status === "ready_to_collect") {
      callout += "سفیران ما در زمان انتخابی شما مراجعه خواهند کرد.";
      calloutColor += "green.main";
    }
  } else if (data?.metadata?.legacy_latest_status === "in_progress") {
    step = 1;
  } else if (
    data?.metadata?.legacy_latest_status === "work_done" ||
    data?.metadata?.legacy_latest_status === "ready_to_deliver"
  ) {
    step = 2;

    if (data?.metadata?.legacy_latest_status === "work_done") {
      callout = "لطفا زمان تحویل مورد نظر خود را مشخص کنید.";
      calloutColor += "orange.main";
    } else {
      callout = "سفیران ما در زمان انتخابی شما مراجعه خواهند کرد.";
      calloutColor += "green.main";
    }
  } else if (data?.metadata?.legacy_latest_status === "delivered") {
    step = 3;
  } else if (
    data?.metadata?.legacy_latest_status === "canceled_by_system" ||
    data?.metadata?.legacy_latest_status === "collection_canceled" ||
    data?.metadata?.legacy_latest_status === "canceled_by_customer"
  ) {
    step = 4;
    callout = "سفارش به درخواست شما لغو شده است.";
  } else if (data?.metadata?.legacy_latest_status === "delivery_canceled") {
    step = 5;
    callout = "تحویل به درخواست شما لغو شده است.";
  } else if (
    data?.metadata?.legacy_latest_status === "collection_not_present"
  ) {
    step = 6;
    callout =
      "در زمان تعیین شده حضور نداشتید. جهت تنظیم زمان مجدد با پشتیبانی تماس بگیرید.";
  } else if (data?.metadata?.legacy_latest_status === "delivery_not_present") {
    step = 7;
    callout =
      "در زمان تعیین شده حضور نداشتید. جهت تنظیم زمان مجدد با پشتیبانی تماس بگیرید.";
  } else {
    callout = "";
    calloutColor = "";
  }

  let [modalVisibility, setModalVisibility] = useState(false);
  let { setCreditModalOpen, setPrefilledValue } = useContext(CreditContext);

  let isCollection =
    data?.metadata?.legacy_latest_status === "ready_to_collect" ||
    data?.metadata?.legacy_latest_status === "collection_canceled";
  let { save, loading: saveLoading } = useSaveBasket(
    isCollection ? "collection" : "delivery",
    {
      order_id: data?.display_id,
    }
  );

  // In case of user open the details page directly,
  // `orders` will be [], so in this case we need to
  // rely on the order itself.

  let credit = profileData ? profileData.total_balance : 0;

  let should_schedule_delivery =
    data?.metadata?.legacy_latest_status === "work_done" ||
    data?.metadata?.legacy_latest_status === "ready_to_deliver";
  data?.metadata?.legacy_latest_status === "delivery_canceled" ||
    data?.metadata?.legacy_latest_status === "delivery_not_present";
  let needsToPay =
    should_schedule_delivery && data?.legacyInvoice.total_price > credit;

  let onSchedule = (task) => {
    save({
      address_id: task.address.id,
      period_id: task.period.id,
      meta: {
        address: task.address.address_text,
        time: scheduledDateTitle(task),
      },
    }).then(() => {
      if (!inPersonAddresses.includes(task.address.id) && data?.in_person) {
        freeLogisticPrice(order_id, false).then(() => {
          revalidate();
        });
      } else {
        revalidate();
      }

      let event_meta = {
        amount: invoice?.total_price,
        orderId: data?.id,
        isRevenue: true,
      };

      logEvent(
        EVENT_TYPES.PURCHASE,
        services_to_ga_purchase(invoice?.total_price, data.services, {
          shipping: invoice?.logistic_price,
          tax: invoice?.vat,
          coupon: data?.legacyPromotion?.code,
        })
      );

      logMetrixEvent(METRIX_EVENT_TYPES.ACTION_REVENUE_ON_DELIVERY, event_meta);
    });
  };

  let onDismiss = () => {
    setIsCancelOrderModalOpen(false);
    setVisibleSelectModeModal(false);
  };

  let formattedCartItems = data && formatOrderItem(data);

  // After getting order data, we are setting proper state
  function refreshData() {
    revalidateProfileData();
    revalidate();
  }
  useEffect(() => {
    // useOrder() dosent get data for the first time
    // we need to call it manually
    refreshData();
    const backAction = () => {
      nav.navigate("Orders");
      return true;
    };

    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      backAction
    );

    return () => backHandler.remove();
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      if (!loading) {
        refreshData();
      }
    }, [loading])
  );

  let dismissModal = () => {
    setModalVisibility(false);
    if (Platform.OS === "web") {
      reset("added_address");
    } else if (Platform.OS === "android") {
      added_address = false;
    }
  };

  let walletAmount =
    Number(profileData?.balance) + Number(profileData?.gift_balance);

  useEffect(() => {
    if (added_address === "true") {
      setModalVisibility(true);
    }
  }, [added_address]);

  useEffect(() => {
    logisticRetrieve();
  }, []);
  return (
    <>
      <Helmet>
        {data ? (
          <title> سفارش {formatNumber(data.display_id)} | دیجی واش</title>
        ) : null}
      </Helmet>
      <PageContainer
        bg="neutrals.250"
        insideBeignScrollView={
          <HeaderContainer>
            <Header
              title="جزییات سفارش"
              action={
                data && data.metadata.can_cancel
                  ? () => setIsCancelOrderModalOpen(true)
                  : null
              }
              onBack={() => {
                nav.navigate("Orders");
              }}
            />
          </HeaderContainer>
        }
        afterScrollView={
          should_schedule_delivery &&
          data?.legacyLogistics?.delivery?.status !== "loaded" ? (
            <Stack distribution="center">
              <Container style={styles.container}>
                <Stack
                  style={{
                    width: "100%",
                    paddingBottom: iosSafeArePadding(),
                  }}
                  distribution="space-between"
                >
                  {needsToPay &&
                  data?.metadata?.legacy_latest_status ===
                    "ready_to_deliver" ? (
                    <Stack
                      style={{ flexGrow: 1, width: "100%" }}
                      distribution="space-between"
                    >
                      <Button
                        fill="primary"
                        style={{
                          width: "100%",
                        }}
                        disabled={saveLoading}
                        onPress={() => {
                          setShowGateways(true);
                          if (!!activeOrders && activeOrders.length > 1) {
                            setVisibleSelectModeModal(true);
                          } else {
                            logEvent(EVENT_TYPES.BUTTON_PAY_ORDER, {
                              type: "delivery",
                            });
                            setCreditModalOpen(true, {
                              origin: "order",
                              order_id: order_id,
                            });
                            setPrefilledValue(
                              Math.ceil(
                                (data.legacyInvoice.total_price - credit) / 10,
                              ),
                            );
                          }
                        }}
                      >
                        پرداخت آنلاین
                      </Button>
                    </Stack>
                  ) : (
                    <Stack
                      style={{ flexGrow: 1, width: "100%" }}
                      distribution="space-between"
                    >
                      <Button
                        fill="primary"
                        style={{
                          width: "45%",
                        }}
                        disabled={saveLoading}
                        onPress={() => {
                          setModalVisibility(true);
                        }}
                      >
                        تعیین زمان تحویل
                      </Button>
                      <Spacer size="l" />
                      <Button
                        outline="primary"
                        style={{ width: "45%" }}
                        disabled={saveLoading}
                        onPress={() => {
                          setModalVisibility(true);
                        }}
                      >
                        پرداخت در محل
                      </Button>
                    </Stack>
                  )}
                </Stack>
              </Container>
            </Stack>
          ) : null
        }
      >
        {!loading && error ? (
          <Stack pt="xxl" distribution="center" direction="vertical">
            <Typography color="red.main" fs="l">
              خطا!
            </Typography>
            <Divider size="s" />
            <Typography color="neutrals.800" fs="xm">
              {error}
            </Typography>
          </Stack>
        ) : (
          <Stack direction="vertical" alignment="stretch" px="xm" pt="xxl">
            {data ? (
              <Box px="xl">
                <Typography color="common.black">
                  شماره سفارش {formatNumber(data.display_id)}
                </Typography>
              </Box>
            ) : null}
            <Divider size="xl" />
            {loading && !data ? <ActivityIndicator color="#0000ff" /> : null}
            {typeof step === "number" && (
              <Indicator
                step={step}
                callout={
                  callout === "" ? null : (
                    <>
                      <Divider size="l" />
                      <Stack px="l" distribution="center">
                        <Typography
                          fs="xm"
                          style={{ textAlign: "center" }}
                          color={calloutColor ? calloutColor : "red.main"}
                        >
                          {callout}
                        </Typography>
                      </Stack>
                    </>
                  )
                }
              />
            )}

            <Divider size="xxl" />
            <Divider size="xxl" />
            <Section
              title="حمل و نقل"
              icon="truck"
              privilegeList={logisticPrivileges}
            >
              <Box>
                {loading && !data ? (
                  <ActivityIndicator color="#0000ff" />
                ) : null}
                {!!data ? (
                  <>
                    <Divider size="xl" />
                    <LogisticsHistory
                      list={data?.legacyHistoryLogistics}
                      status={data?.metadata?.legacy_latest_status}
                      theme={theme}
                      icons={{
                        normal: <Dot />,
                        active: <Dot active />,
                        time: (
                          <CustomIcon
                            icon="logisticTime"
                            width={20}
                            height={20}
                          />
                        ),
                      }}
                      onReschedule={(item) => {
                        setModalVisibility(true);
                        setLogisticSelectedTask(item);
                      }}
                      onAdd={() => {
                        setModalVisibility(true);
                      }}
                      policy="customer"
                    />
                    <Divider size="xl" />
                  </>
                ) : null}
              </Box>

              <ModalScheduleLogistic
                selectedAddressAndTimesheet={
                  logisticSelectedTask
                    ? {
                        address_id: logisticSelectedTask.address_id,
                        address_text: logisticSelectedTask.address_text,
                        period: logisticSelectedTask.period,
                      }
                    : undefined
                }
                type={isCollection ? "collection" : "delivery"}
                visible={modalVisibility}
                dismissModal={dismissModal}
                isReschedule={
                  data?.metadata?.legacy_latest_status !== "work_done"
                }
                onAction={(selectedAddress, selectedTimesheet) => {
                  let taskType =
                    data?.metadata?.legacy_latest_status ===
                      "ready_to_deliver" ||
                    data?.metadata?.legacy_latest_status ===
                      "delivery_canceled" ||
                    data?.metadata?.legacy_latest_status ===
                      "delivery_not_present"
                      ? "delivery"
                      : "collection";
                  let taskTypeText =
                    taskType === "collection" ? "جمع آوری" : "تحویل";
                  if (data?.metadata?.legacy_latest_status === "work_done") {
                    onSchedule({
                      period: selectedTimesheet,
                      address: selectedAddress,
                    });
                  } else {
                    rescheduleOrder({
                      orderId: order_id,
                      address: selectedAddress?.id,
                      period: selectedTimesheet?.id,
                      type: taskType,
                    })
                      .then(() => {
                        if (
                          !inPersonAddresses.includes(selectedAddress?.id) &&
                          data?.in_person
                        ) {
                          freeLogisticPrice(order_id, false).then(() => {
                            revalidate();
                          });
                        } else {
                          revalidate();
                        }

                        toast.show(
                          `زمان و مکان ${taskTypeText} سفارش شما با موفقیت ثبت شد.`,
                          {
                            data: { type: "success" },
                          }
                        );
                      })
                      .catch(() => {
                        toast.show(
                          `مشکلی در ثبت زمان و مکان ${taskTypeText} پیش آمده.`,
                          {
                            data: { type: "danger" },
                          }
                        );
                      });
                  }

                  dismissModal();
                }}
                origin_page="Order"
                order_id={order_id}
                in_person={data?.in_person}
              />
            </Section>
            <Divider size="xxl" />
            <Divider size="xxl" />

            <Section title="سفارش شما" icon="orderOnProgress">
              <Box p="l">
                {loading && !data ? (
                  <ActivityIndicator color="#0000ff" />
                ) : null}
                {!!data && formattedCartItems.length === 0 ? (
                  <Stack distribution="center">
                    <Typography color="common.black">
                      خدماتی ثبت نشده است.
                    </Typography>
                  </Stack>
                ) : null}
                {!!formattedCartItems &&
                  formattedCartItems.map((data, index) => {
                    return (
                      <>
                        <CartItem data={data} readonly />
                        {formattedCartItems.length - 1 === index ? null : (
                          <Divider size="m" />
                        )}
                      </>
                    );
                  })}
              </Box>
            </Section>
            <Divider size="xxl" />
            <Divider size="xxl" />

            <Section
              title="صورتحساب"
              icon="receipt"
              subTitle={
                !!data?.metadata?.legacy_factor_link ? (
                  <Button
                    type="circle-like"
                    bg="primary.main"
                    size="m"
                    onPress={() => {
                      Linking.openURL(data.metadata.legacy_factor_link);
                    }}
                  >
                    دانلود قبض
                  </Button>
                ) : null
              }
            >
              <Box p="l">
                {loading && !data ? (
                  <Box p="l">
                    <ActivityIndicator color="#0000ff" />
                  </Box>
                ) : null}
                {!!data ? (
                  <BasketInvoiceNew
                    invoice={data?.legacyInvoice}
                    bg="common.white"
                    walletAmount={walletAmount}
                    logisticPrice={logisticPrice}
                  />
                ) : null}
              </Box>
            </Section>

            <Divider size="huge" />
            {should_schedule_delivery ? <Divider size="huge" /> : null}
          </Stack>
        )}

        <Modal
          isVisible={isCancelOrderModalOpen}
          onSwipeComplete={onDismiss}
          onBackdropPress={onDismiss}
          swipeDirection={["down"]}
          style={{
            justifyContent: "flex-end",
            margin: 0,
            width: "100%",
            alignItems: "center",
          }}
        >
          <ModalContent>
            <Box pt="xxl" px="l" pb="l">
              <Stack>
                <CustomIcon icon="delete" width={24} height={24} />
                <Spacer size="m" />
                <Typography ff="mainBold" fs="l" color="common.black">
                  لغو سفارش
                </Typography>
              </Stack>
              <Divider size="l" />
              <Box px="xxxl">
                <Typography color="common.black">
                  آیا از لغو سفارش اطمینان دارید؟
                </Typography>
              </Box>
              <Divider size="xxl" />
              <Stack distribution="end">
                <Stack>
                  <Button
                    onPress={() => {
                      onDismiss();
                    }}
                    textColor="common.black"
                    fill="transparent"
                  >
                    منصرف شدم
                  </Button>
                  <Spacer size="xxl" />
                  <Button
                    onPress={() => {
                      cancelOrder(order_id)
                        .then(() => {
                          revalidate();

                          logEvent(EVENT_TYPES.COLLECTION_CANCEL, {});
                          logMetrixEvent(
                            METRIX_EVENT_TYPES.COLLECTION_CANCEL,
                            {}
                          );
                        })
                        .catch((e) => {
                          toast.show(formatError(e.response), {
                            data: { type: "danger" },
                          });
                        });
                      setIsCancelOrderModalOpen(false);
                    }}
                    textColor="red.main"
                    fill="transparent"
                  >
                    بله، لغو شود
                  </Button>
                </Stack>
              </Stack>
            </Box>
          </ModalContent>
        </Modal>
        <Modal
          isVisible={visibleSelectModeModal}
          onSwipeComplete={onDismiss}
          onBackdropPress={onDismiss}
          swipeDirection={["down"]}
          style={{
            justifyContent: "flex-end",
            margin: 0,
            width: "100%",
            alignItems: "center",
          }}
        >
          <ModalContent>
            <Box pt="xxl" px="l" pb="l">
              <Button
                onPress={() => {
                  setVisibleSelectModeModal(false);
                  setShowGateways(true);
                  if (needsToPay) {
                    logEvent(EVENT_TYPES.BUTTON_PAY_ORDER, {
                      type: "delivery",
                    });
                    setCreditModalOpen(true, {
                      origin: "order",
                      order_id: order_id,
                    });
                    setPrefilledValue(
                      Math.ceil((data.legacyInvoice.total_price - credit) / 10)
                    );
                  } else {
                    setModalVisibility(true);
                  }
                }}
              >
                پرداخت همین سفارش
              </Button>
              <Divider size="xxl" />
              <Button
                onPress={() => {
                  setVisibleSelectModeModal(false);
                  setShowGateways(true);
                  logEvent(EVENT_TYPES.BUTTON_PAY_ORDER, {
                    type: "delivery",
                  });
                  setCreditModalOpen(true, {
                    origin: "order",
                    order_id: order_id,
                  });
                  setPrefilledValue(
                    Math.ceil(
                      (totalActiveOrdersPrice(activeOrders) - credit) / 10
                    )
                  );
                }}
              >
                پرداخت {formatNumber(activeOrders.length)} سفارش آماده تحویل
              </Button>
            </Box>
          </ModalContent>
        </Modal>
        <ModalAddCredit
          isGateways={showGateways}
          hasShopService={hasShopService}
        />
      </PageContainer>
    </>
  );
}

export default OrderDetails;
